export const PHASES = [
  {
    title: "Elementos básicos",
    shortTitle: "Básicos",
    description: "Encontre elementos comuns do dia a dia.",
    elements: ["H", "O", "C", "N"],
  },
  {
    title: "Metais essenciais",
    shortTitle: "Metais",
    description: "Descubra metais presentes em objetos e no corpo.",
    elements: ["Fe", "Cu", "Al", "Ca"],
  },
  {
    title: "Gases nobres",
    shortTitle: "Gases",
    description: "Localize elementos conhecidos pela estabilidade.",
    elements: ["He", "Ne", "Ar", "Kr"],
  },
  {
    title: "Metais alcalinos",
    shortTitle: "Alcalinos",
    description: "Reconheça elementos reativos do grupo 1.",
    elements: ["Li", "Na", "K", "Rb"],
  },
  {
    title: "Halogênios",
    shortTitle: "Halogênios",
    description: "Encontre os elementos do grupo 17.",
    elements: ["F", "Cl", "Br", "I"],
  },
  {
    title: "Elementos da vida",
    shortTitle: "Vida",
    description: "Localize elementos essenciais aos seres vivos.",
    elements: ["P", "S", "Mg", "Zn"],
  },
  {
    title: "Metais de transição",
    shortTitle: "Transição",
    description: "Encontre elementos importantes do bloco d.",
    elements: ["Mn", "Cr", "Ni", "Co"],
  },
  {
    title: "Tecnologia",
    shortTitle: "Tecnologia",
    description: "Descubra elementos usados em eletrônicos.",
    elements: ["Si", "Ge", "Ga", "In"],
  },
  {
    title: "Metais raros",
    shortTitle: "Raros",
    description: "Localize metais preciosos e pouco abundantes.",
    elements: ["Au", "Pt", "Ag", "Os"],
  },
];

export const TARGETS_PER_PHASE = 4;
